import { Component } from "react";
import { AiFillMail } from "react-icons/ai";
class Contact extends Component {
  render() {
    return (
      <div className="contact">
        <a href="mailto:razzo@razzomedia.com">
          <AiFillMail />
          <span>razzo@razzomedia.com</span>
        </a>
      </div>
    );
  }
}

export default Contact;
